import { render, staticRenderFns } from "./OrderReportGridDelete.vue?vue&type=template&id=59b0cc78"
import script from "./OrderReportGridDelete.vue?vue&type=script&lang=js"
export * from "./OrderReportGridDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports